export default __webpack_public_path__ + "static/media/Q_Quadrado.fded40ca.svg";